export interface ThemeColors {
    readonly name: string;
    readonly themeClass: string;
}

export const THEME_COLORS: ThemeColors[] = [
    { name: "Blue, Pink & Yellow", themeClass: "default-theme" },
    //   { name: 'Purple Theme', themeClass: 'purple-theme' },
    //   { name: 'Green Theme', themeClass: 'green-theme' },
];
